import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, PropsWithChildren, useMemo } from 'react';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { assertNotNullOrUndefined } from 'record-it-utils/utils/assert/assertNotNullOrUndefined';
import { UserPermissions } from '../classes/misc/UserPermissions/UserPermissions';
import { CurrentUserContext, CurrentUserContextValue } from '../context/CurrentUserContext';
import { useCurrentUserData } from '../hooks/authentication/useCurrentUserData/useCurrentUserData';
import { useAuth } from '../hooks/useAuth';
export const AppCurrentUserContextProvider: FunctionComponent<PropsWithChildren> = React.memo(props => {
  const $ = _c(15);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    children
  } = t0;
  const {
    authenticationData
  } = useAuth();
  const currentUserData = useCurrentUserData(authenticationData);
  let t1;
  if ($[2] !== currentUserData) {
    t1 = currentUserData ? new UserPermissions(currentUserData) : null;
    $[2] = currentUserData;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const currentUserPermissions = t1;
  const t2 = currentUserData?.user ?? null;
  let t3;
  if ($[4] !== currentUserData) {
    t3 = () => {
      assertNotNullOrUndefined(currentUserData, "no currentUserData available");
      return currentUserData.user;
    };
    $[4] = currentUserData;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== currentUserPermissions) {
    t4 = () => {
      assertNotNullOrUndefined(currentUserPermissions, "no currentUserPermissions available");
      return currentUserPermissions;
    };
    $[6] = currentUserPermissions;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = {
      currentUser: t2,
      getRequiredCurrentUser: t3,
      getRequiredCurrentUserPermissions: t4
    };
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const contextValue = t5;
  let t6;
  if ($[12] !== children || $[13] !== contextValue) {
    t6 = <CurrentUserContext.Provider value={contextValue}>{children}</CurrentUserContext.Provider>;
    $[12] = children;
    $[13] = contextValue;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
});